import axios from 'axios';
import { baseUrl } from '../../utils/constants/constants';
import { IndicacaoApiResponse, IndicacaoIndicador } from './indicacao.types';

export const getIndicacaoIndicador = async (codigo: string) => {
	const url = `${baseUrl}v2/Indicacao/Indicador/${encodeURIComponent(codigo)}`;
	const response = await axios.get<IndicacaoApiResponse<IndicacaoIndicador>>(url);
	return response.data;
};
